import { createAsyncThunk } from '@reduxjs/toolkit';
import { SalesService } from '../../../shared/api/model/service/sales.service';

export const fetchSalesAsync = createAsyncThunk('sales/fetchSales', async (date: string) => {
  return await SalesService.getSaleProductByDate(date);
});
